module.exports = __webpack_public_path__ + "assets/message-1bcc31.svg";